angular.module('zc.zenclerkS')
  .component('zcsNotificationPanel', {
    templateUrl: '/templates/zenclerk_s/directives/notification/notification-panel.html',
    controller: zcsNotificationPanel
  });


zcsNotificationPanel.$inject = ['$scope', 'ZcsLayout'];
function zcsNotificationPanel($scope, ZcsLayout) {
  const vm = this;

  this.$onInit = () => {
    vm.togglePanel = togglePanel;
    vm.isPanelActive = false;
    vm.ZcsLayout = ZcsLayout;

    $scope.$watch(() => ZcsLayout.isSidebarVisible, newval => {
      vm.isPanelActive = newval;
    });
  };

  function togglePanel() {
    ZcsLayout.isSidebarVisible = !ZcsLayout.isSidebarVisible;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/notification/notification-panel.js